import React from 'react'
import { Modal } from 'antd'
import { connect } from 'react-redux'
import getConfig from 'next/config'
import { showItemDetail } from '../../actions'

const { publicRuntimeConfig } = getConfig()

const SuggestedProductBannerModal = ({ suggestedProduct, displayLocation, visible, onClose, showItemDetail }) => {
  if (!suggestedProduct) return null

  const imagePath = `${publicRuntimeConfig.suggestedProductImagesBasePath}${suggestedProduct.image}`

  const handleImageClick = () => {
    onClose()
    if (suggestedProduct.product) {
      showItemDetail({
        show: true,
        showDealLabel: false,
        item: { ...suggestedProduct.product },
        source: 'suggested_product_banner',
        displayLocation,
      })
    }
  }

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={560} centered>
      <img
        alt={suggestedProduct.product?.descripcion}
        src={imagePath}
        onClick={handleImageClick}
        style={{ width: '100%', cursor: 'pointer', display: 'block', borderRadius: 4 }}
        onError={(e) => {
          e.target.onerror = null
          e.target.src = '/static/images/no-image.jpg'
        }}
      />
    </Modal>
  )
}

export default connect(null, { showItemDetail })(SuggestedProductBannerModal)
